import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProProvider } from "@/context/ProContext";
import { TourProvider } from "@/tour/TourContext";
import { DashboardLayout } from "@/layouts/DashboardLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import DailyPicks from "@/pages/DailyPicks";
import Scores from "@/pages/Scores";
import Bookmakers from "@/pages/Bookmakers";
import Players from "@/pages/Players";
import Games from "@/pages/Games";
import Simulate from "@/pages/Simulate";
import Parlay from "@/pages/Parlay";
import MyBets from "@/pages/MyBets";
import Rankings from "@/pages/Rankings";
import Factors from "@/pages/Factors";
import CLV from "@/pages/CLV";

function App() {
  // apply theme attr from localStorage on first render
  React.useEffect(() => {
    const saved = localStorage.getItem("ge_theme");
    if (saved === "dark") {
      document.documentElement.setAttribute("data-theme", "dark");
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
    }
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ProProvider>
            <TourProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route element={<DashboardLayout />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/scores" element={<Scores />} />
                  <Route path="/daily-picks" element={<DailyPicks />} />
                  <Route path="/games" element={<Games />} />
                  <Route path="/bookmakers" element={<Bookmakers />} />
                  <Route path="/players" element={<Players />} />
                  <Route path="/simulate" element={<Simulate />} />
                  <Route path="/parlay" element={<Parlay />} />
                  <Route path="/my-bets" element={<MyBets />} />
                  <Route path="/rankings" element={<Rankings />} />
                  <Route path="/factors" element={<Factors />} />
                  <Route path="/clv" element={<CLV />} />
                </Route>
              </Routes>
            </TourProvider>
          </ProProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
